import React, { useRef, useState } from 'react';

interface AttachmentElementProps {
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  index: number;
  accept?: string;
}


const AttachmentElement: React.FC<AttachmentElementProps> = ({ label, name, onChange, index, accept = '.jpg,.png,.gif' }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string>("");

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("");
    }
    onChange(e, index);
  };

  return (
    <div className="mb-4">
      <label className="block text-primary-dark font-medium mb-2">{label}</label>
      <button
        type="button"
        onClick={handleButtonClick}
        className="flex items-center gap-2 px-5 py-3 rounded-2xl bg-primary-light text-white font-semibold shadow-md hover:bg-primary-dark transition focus:outline-none focus:ring-2 focus:ring-primary-light"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.586-6.586a4 4 0 10-5.656-5.656l-6.586 6.586a6 6 0 108.485 8.485l6.586-6.586" /></svg>
        Datei auswählen
      </button>
      <input
        ref={inputRef}
        id={`${name}_${index}`}
        name={name}
        type="file"
        accept={accept}
        onChange={handleChange}
        className="hidden"
      />
      {fileName && (
        <div className="mt-2 text-primary-dark bg-primary-light/10 rounded-lg px-4 py-2 text-sm truncate max-w-full" title={fileName}>
          {fileName}
        </div>
      )}
    </div>
  );
};

export default AttachmentElement;
